"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorComponent_1 = __importDefault(require("./ErrorComponent"));
exports.default = ErrorComponent_1.default;
//# sourceMappingURL=index.js.map